import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=68548eb8"
import script from "./Inputs.vue?vue&type=script&lang=ts"
export * from "./Inputs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports